import styled, { css } from 'styled-components'
import { tabletBreakpoint, desktopBreakpoint, wideScreenBreakpoint } from 'react-components'

export const Container = styled.section(
    ({ theme }) => css`
        width: inherit;
        padding: 1rem 0 0.5rem;
        overflow: hidden;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            padding: 2rem 0 1rem;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            padding: 2rem 1.5rem 1rem;
        }

        @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
            padding: 2rem 4rem 1rem;
        }
    `,
)

export const InnerContainer = styled.div`
    margin-top: 1rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin-top: 0.5rem;
    }
`

export const DestinationContainer = styled.div`
    display: flex;
`
